var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "cargo-company-select",
    _vm._g(
      _vm._b(
        {
          attrs: {
            multiple: _vm.multiple,
            "default-value": _vm.multiple ? "" : _vm.value,
            "default-multiple-value": _vm.multiple ? _vm.value : []
          },
          on: { change: _vm.onChange }
        },
        "cargo-company-select",
        _vm.$attrs,
        false
      ),
      _vm.new$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }